import React from 'react';

import Login from './components/Login';

import './Auth.layout.css';

export default () => {
  return (
    <div className="Auth">
      <Login />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/auth/Auth.layout.jsx